module.exports = __WEBPACK_EXTERNAL_MODULE_340__;


//////////////////
// WEBPACK FOOTER
// external "_"
// module id = 340
// module chunks = 1